import axiosHttp from "./interceptor.service";

export const fixGrammarAndSpell = (text) =>
  axiosHttp.post("/grammar-spell-fixer", { text });
